export function MiniScoreBar({ score }: { score: number }) {
  return (
    <div style={{ marginBottom: 4 }}>
      <div
        style={{
          height: 5,
          background: "#e8eaf0",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${score * 100}%`,
            background:
              score >= 0.8 ? "#2f9e44" : score >= 0.5 ? "#e67700" : "#c92a2a",
            borderRadius: 3,
          }}
        />
      </div>
    </div>
  );
}
